import { NoBlending, ShaderMaterial, Uniform } from "three";

import fragmentShaderSource from "./glsl/ACES.frag";
import vertexShader from "./glsl/Common.vert";

/**
 * A simple copy shader material.
 */

export class ACESMaterial extends ShaderMaterial {

    /**
     * Constructs a new ACES material.
     */

    constructor(type, options) {
        let fragmentShader = fragmentShaderSource;

        if (type === "IDT") {
            // bypass?
            if (options.value === "IDT100") fragmentShader = fragmentShader.replace("{{BIG_BYPASS}}", 1);
            else fragmentShader = fragmentShader.replace("{{BIG_BYPASS}}", 0);

            // IDT
            if (options.value === "IDT100_ACES") fragmentShader = fragmentShader.replace("{{IDT}}", "IDT100");
            else if (options.value === "IDT169") fragmentShader = fragmentShader.replace("{{IDT}}", "IDT100");
            else if (options.value === "IDT170") fragmentShader = fragmentShader.replace("{{IDT}}", "IDT100");
            else if (options.value === "IDT171") fragmentShader = fragmentShader.replace("{{IDT}}", "IDT100");
            else fragmentShader = fragmentShader.replace("{{IDT}}", options.value);

            // LMT
            if (options.ACES_LMT) fragmentShader = fragmentShader.replace("{{LMT}}", "LMT203");
            else fragmentShader = fragmentShader.replace("{{LMT}}", "LMT200");

            // RRT
            fragmentShader = fragmentShader.replace("{{RRT}}", "RRT300");

            // ODT
            if (options.ACES_ODT) fragmentShader = fragmentShader.replace("{{ODT}}", options.ACES_ODT);
            else fragmentShader = fragmentShader.replace("{{ODT}}", "ODT402");

            // INVODT
            if (options.value === "IDT169") fragmentShader = fragmentShader.replace("{{INVODT}}", "INVODT510")
            if (options.value === "IDT170") fragmentShader = fragmentShader.replace("{{INVODT}}", "INVODT511")
            if (options.value === "IDT171") fragmentShader = fragmentShader.replace("{{INVODT}}", "INVODT512")
            else fragmentShader = fragmentShader.replace("{{INVODT}}", "INVODT500");

            // INVRRT
            if (options.value === "IDT169") fragmentShader = fragmentShader.replace("{{INVRRT}}", "INVRRT601")
            if (options.value === "IDT170") fragmentShader = fragmentShader.replace("{{INVRRT}}", "INVRRT601")
            if (options.value === "IDT171") fragmentShader = fragmentShader.replace("{{INVRRT}}", "INVRRT601")
            else fragmentShader = fragmentShader.replace("{{INVRRT}}", "INVRRT600");

            // RRTODT
            fragmentShader = fragmentShader.replace("{{RRTODT}}", "RRTODT700");
        } else if (type === "ODT") {
            //bypass?
            if (options.value === "ODT400") fragmentShader = fragmentShader.replace("{{BIG_BYPASS}}", 1);
            else fragmentShader = fragmentShader.replace("{{BIG_BYPASS}}", 0);

            // IDT
            fragmentShader = fragmentShader.replace("{{IDT}}", "IDT102");

            // LMT
            fragmentShader = fragmentShader.replace("{{LMT}}", "LMT200");

            if (options.type === "RRTODT") {
                fragmentShader = fragmentShader.replace("{{RRT}}", "RRT300");
                fragmentShader = fragmentShader.replace("{{ODT}}", "ODT400");
                fragmentShader = fragmentShader.replace("{{RRTODT}}", options.value);
            } else {
                if (options.value == "ODT403") fragmentShader = fragmentShader.replace("{{RRT}}", "RRT300");
                else fragmentShader = fragmentShader.replace("{{RRT}}", "RRT301");
                fragmentShader = fragmentShader.replace("{{ODT}}", options.value);
                fragmentShader = fragmentShader.replace("{{RRTODT}}", "RRTODT700");
            }

            // INVODT
            fragmentShader = fragmentShader.replace("{{INVODT}}", "INVODT500");

            // INVRRT
            fragmentShader = fragmentShader.replace("{{INVRRT}}", "INVRRT600");
        }

        super({
            name: "ACESMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0)
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });

        /** @ignore */
        this.toneMapped = false;

    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
